import { useAuth } from '@/providers/auth-provider';
import { Navigate } from 'react-router-dom';
import { Shield } from 'lucide-react';

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50 dark:bg-background">
        <div className="flex flex-col items-center gap-4">
          <Shield className="h-12 w-12 text-blue-600 animate-pulse" />
          <p className="text-sm text-muted-foreground dark:text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
